import { useTranslation } from 'react-i18next';
import { UIButton, UIModal, UIModalProps, UITypography } from 'shared/ui';
import styles from './style.module.scss';
import { TickCircle } from 'assets/icons/tick-circle';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'shared/constants';

type WithdrawSuccessModalProps = UIModalProps & {
  amount?: number;
  transactionId?: string;
  error?: string;
  onClose: () => void;
};

export const WithdrawSuccessModal = ({
  amount,
  transactionId,
  error,
  onClose,
  ...props
}: WithdrawSuccessModalProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isSuccess = !error;

  const handleGoToHistory = () => {
    onClose();
    navigate(ROUTES.BAKERY, { state: { activeWindow: 'withdrawals' } });
  };

  return (
    <UIModal {...props} onClose={onClose} detent="content-height">
      <div className={styles.root}>
        <div className={styles.iconWrapper}>
          {isSuccess ? (
            <div className={styles.successIcon}>
              <TickCircle />
            </div>
          ) : (
            <div className={styles.errorWrapper}>
              <div className={styles.errorIcon}>!</div>
            </div>
          )}
        </div>

        <UITypography variant="H1" className={styles.title}>
          {isSuccess ? t('v2.withdrawal.success_title') : t('v2.withdrawal.error_title')}
        </UITypography>

        <UITypography className={styles.message}>
          {isSuccess
            ? t('v2.withdrawal.success_message')
            : error || t('v2.withdrawal.error_generic')}
        </UITypography>

        {isSuccess && amount && (
          <div className={styles.amountInfo}>
            <UITypography className={styles.amountLabel}>{t('v2.withdrawal.amount')}:</UITypography>
            <UITypography className={styles.amountValue}>{amount.toFixed(2)} USDT</UITypography>
          </div>
        )}

        {isSuccess && transactionId && (
          <UITypography className={styles.transactionId}>ID: {transactionId}</UITypography>
        )}

        {isSuccess && (
          <UIButton
            onClick={handleGoToHistory}
            fullwidth
            className={styles.btn}
            variant="primary"
          >
            {t('v2.withdrawal.go_to_history')}
          </UIButton>
        )}
        
        <UIButton
          onClick={onClose}
          fullwidth
          variant="secondary"
        >
          {t('common.close')}
        </UIButton>
      </div>
    </UIModal>
  );
};
